import React from 'react';

import { ReactComponent as Spinner } from './images/spinner.svg';

const Loading = () => {
  return (
    <div style={{
           width: '100%',
           height: 'calc(100vh - 200px)',
           alignItems: 'center',
           display: 'flex',
           justifyContent: 'center',
         }}>
      <div style={{
             textAlign: 'center',
             color: 'white',
           }}>
        <Spinner style={{
                   margin: '0 auto',
                   width: '80px',
                   height: '80px',
                   animation: 'spin 1s linear infinite',
                 }} />
        <p>Loading...</p>
      </div>
    </div>
  );
}

export default Loading;
